export function reformatCatsData(data){
   return data
 }

 const getSeries=(rawdata,colName)=>{
     let  out =[];
   rawdata.forEach(element => {
       out.push(element[colName])
    });


 return out;

}



export function  reFormatDevicesData(data){
    return {
      day:[
        {
          label: 'Total Distance',
          key:'distance',
          export:'DevicesDistanceList',
          value: data.Distances, 
          filters: {zeroDistance:false},
          unit: 'Kilometers'
        },
        {
          label: 'Total Engine Hours', 
          key:'hours',
          export:'DevicesHoursList',
          value: data.Hours, 
          filters: {zeroHours:false},
          unit: 'Hours'
        },
        {
          label: 'Average Speed', 
          key:'avgSpeed',
          export:'DevicesAvgSpeedList',
          value: data.AvgSpeed, 
          filters: {zeroAvgSpeed:false},
          unit: 'km/h'
        },
        {
          label: 'Speed Limit Violations', 
          key:'overspeedingTimes',
          export:'DevicesOverspeedingList',
          value: data.OverspeedingTimes, 
          filters: {zeroOverspeedingTimes:false},
          unit: 'Violations'
        }
      ],
      status:[
         {
             icon:'WifiIcon',
             color: ['#04d600', '#d61002'],
             count: [data.Online, data.Offline],
             key: ['Online', 'Offline'],
             label:['Online Devices', 'Offline Devices'],
             tip_text:['The count of online devices', 'The count of offline devices'],
             totalLabel:'Total Devices',
             customClass: 'mb-1 mb-xl-0',
             filters:[{isOnline:true}, {isOnline:false}],
             fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
          },
         {
             icon:'ZapIcon',
             color: ['#04d600', '#d61002'],
             count: [data.Working, data.Stopped],
             key: ['Working', 'Stopped'],
             label:['Working Engine', 'Stopped Engine'],
             tip_text:['The count of devices with running engine', 'The count of devices with stopped engine'],
             totalLabel:'Online Devices',
             customClass: 'mb-1 mb-xl-0',
             filters:[{isOnline:true, isWorking:true}, {isOnline:true, isWorking:false}],
             fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
           },
          {
             icon:'ActivityIcon',
             color: ['#04d600', '#d61002'],
             count: [data.Moving, data.Idle],
             key: ['Moving', 'Idle'],
             label:['Moving Devices', 'Idle Devices'],
             tip_text:['The count of current moving devices', 'The count of current idle devices'],
             totalLabel:'Working Devices',
             customClass: 'mb-1 mb-xl-0',
             filters:[{isOnline:true, isWorking:true, isMoving:true}, {isOnline:true, isWorking:true, isMoving:false}],
             fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
           },
           {
             icon:'ClockIcon',
             color: ['#04d600', '#d61002'],
             count: [data.Present, data.Absent],
             key: ['Present', 'Absent'],
             label:['Present Devices', 'Absent Devices'],
             tip_text:['The count of current present devices', 'The count of current absent devices'],
             totalLabel:'Total Devices',
             customClass: 'mb-1 mb-xl-0',
             filters:[{isAbsent:false}, {isAbsent:true}],
             fields:[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
           }
   ]}
    
       
   }

export function  reFormatGardenData(data){
   let current_data=[];
   current_data=data;
  let planedData=[];
  let servedData=[];
  let labelData=[];
  let  list=[];
  let out=[]

  labelData=[];
    
  



  for(const i in current_data){

  planedData.push(current_data[i].planned)
  servedData.push(current_data[i].served)
  labelData.push(current_data[i].name)
  list.push(current_data[i].list)


  }



   out.push({
    labels_data:labelData,
    series_data:[
      {
       name:"Planed",
       data:planedData
      },
       {
          name:"Served",
          data: servedData
        },

    ],
    listOfData:list


   })
   

  return out[0];





}
